module.exports = __webpack_public_path__ + "media/src/images/logo-61773f8981abb2739d6e50f200a3a488.png";